<template>
  <div class="hris-page">
    <div class="hris-page-inner">
      <div class="hris-page-header hris-page-header-row">
        <div>
          <span class="hris-page-eyebrow">Payslip</span>
          <h1 class="hris-page-title">My Payslips</h1>
          <p class="hris-page-subtitle">View your released payslips and 13th month pay statements.</p>
        </div>
        <q-btn flat dense class="hris-q-ghost" label="I forgot my payslip password?" @click="forgotPassword"></q-btn>
      </div>

      <div class="hris-panel">
        <div class="hris-panel-title">List of Payslip</div>
        <div v-if="payslipList.length <= 0" class="hris-empty">No payslips released yet.</div>
        <div v-else class="hris-grid">
          <div class="hris-content-card" style="cursor: pointer;" v-for="payslip in payslipList" :key="payslip.id" @click="selectedRow(payslip)">
            <div class="hris-content-card-body">
              <div class="hris-content-card-title">Payroll Date: {{ payslip.paydate }}</div>
              <div class="hris-content-card-meta">Cut-off Period: {{ payslip.payroll_from }} - {{ payslip.payroll_to }}</div>
            </div>
            <div class="hris-content-card-footer" v-if="payslip.is_new">
              <span class="hris-badge hris-badge-success">New!</span>
            </div>
          </div>
        </div>
      </div>

      <div class="hris-panel">
        <div class="hris-panel-title">List of 13th Month Pay</div>
        <div v-if="thirteenthMonthPay.length <= 0" class="hris-empty">No 13th month pay records yet.</div>
        <div v-else class="hris-grid">
          <div class="hris-content-card" style="cursor: pointer;" v-for="thirteenth in thirteenthMonthPay" :key="thirteenth.id" @click="selectedThirteenth(thirteenth)">
            <div class="hris-content-card-body">
              <div class="hris-content-card-title">Payroll Date: Dec {{ thirteenth.year }}</div>
              <div class="hris-content-card-meta">Cut-off Period: Jan {{ thirteenth.year }} - Dec {{ thirteenth.year }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <q-dialog v-model="spinner" persistent>
      <div class="hris-loading">
        <q-spinner color="green" size="3em"></q-spinner>
      </div>
    </q-dialog>
    <showDialog></showDialog>
    <ForgotPassword></ForgotPassword>
    <ValidatePassword></ValidatePassword>
    <ThirteenthMonth></ThirteenthMonth>
  </div>
</template>

<script>
import axios from 'axios';
import mixins from '../../mixins';
import showDialog from './Details';
import ForgotPassword from './ForgotPassword';
import ValidatePassword from './ValidatePassword';
import ThirteenthMonth from './ThirteenthMonth';
export default {
   components: {
     "showDialog": showDialog,
     "ForgotPassword": ForgotPassword,
     "ValidatePassword": ValidatePassword,
     "ThirteenthMonth": ThirteenthMonth,
   },
  data () {
    return {
      spinner:false,
      payslipList:[],
      mobileNumber:'',
      thirteenthMonthPay:[],
    }
  },

  mounted(){
    this.getPayslipList();
    this.getMobileNumber();

    this.get13thMonthPayList();
  },


  methods:{

   getPayslipList: function() {
     this.loadingText = 'Retrieving Data';
     this.spinner = true;
     axios.create({
         baseURL: this.apiUrl,
         headers: {
           'Authorization': `Bearer ${this.token}`
         }
      })
      .get(`/mobile/payslip/list/${this.userData.employee_id}`)
      .then((res) => {
         this.payslipList = res.data
         this.spinner = false;
      })
      .finally(() => {
         this.spinner = false;
         this.loadingText = '';
      })
   },

   get13thMonthPayList: function() {
     this.loadingText = 'Retrieving Data';
     this.spinner = true;
     axios.create({
         baseURL: this.apiUrl,
         headers: {
           'Authorization': `Bearer ${this.token}`
         }
      })
      .get(`/mobile/thirteenth/month/list/${this.userData.employee_id}`)
      .then((res) => {
         this.thirteenthMonthPay = res.data
         this.spinner = false;
      })
      .finally(() => {
         this.spinner = false;
         this.loadingText = '';
      })
   },

   getMobileNumber:function(){
      axios.create({
            baseURL: this.apiUrl,
            headers: {
             'Authorization': `Bearer ${this.token}`
            }
         })
         .get(`/mobile/number`)
         .then((res) => {
           this.mobileNumber = res.data.data
         })
   },

   selectedRow(payslip) {
     this.eventHub.$emit('validatePassword', { stat: true,type:'payslip', payslip: payslip });
   },

   selectedThirteenth(thirteenthMonth) {
     this.eventHub.$emit('validatePassword', { stat: true,type:'thirteenthMonth', thirteenthMonth: thirteenthMonth });
   },

   forgotPassword() {
     this.eventHub.$emit('forgotPassword', { stat: true, mobile: this.mobileNumber});
   },


   }
}
</script>
